/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { Alert } from "UpduoLibrary";
import * as UpduoAnalytics from "config/UpduoAnalytics";

export async function requestSessionPermissions(
  successCallback: (success: boolean) => void = () => {},
  errorCallback: () => void = () => {}
) {
  // Check camera and microphone permissions
  navigator.mediaDevices
    .getUserMedia({ video: true, audio: true })
    .then((stream) => {
      // We don't need the stream, just the permissions
      stream.getTracks().forEach((track) => {
        track.stop();
      });
      successCallback(true);
    })
    .catch((error) => {
      UpduoAnalytics.logEvent("user-permissions-refuse", { error });
      // User refused permissions previously; show user instructions via an alert
      Alert(
        "Upduo sessions are video chats, but your camera and/or microphone is not accessible!\nPlease check the following:",
        "\n1. Try refreshing your browser and trying again. If the issue persists, see below.\n\n2. In your browser's settings, either enable camera and microphone permissions, or clear 'upduo.com' browser cookies.\n\n3. Close any other apps or browser windows/tabs using camera or microphone (Zoom, Microsoft Teams, Google Meet, etc.).",
        [
          {
            text: "Okay",
            onPress: () => {
              errorCallback();
            },
          },
        ]
      );
    });
}
